import React from 'react';
import styled from 'styled-components';
import { SocialIcon } from 'react-social-icons';
import { Phone } from 'lucide-react';

const PHONE_DISPLAY = '(423) 660-9125';
const PHONE_LINK = 'tel:+14236609125';
const FACEBOOK_URL = 'https://www.facebook.com/profile.php?id=61562666398013';

const ContactWrapper = styled.div`
  max-width: 600px;
  margin: 0 auto;
  padding: 0 20px;
`;

const Title = styled.h1`
  color: #0C2340;
  text-align: center;
`;

const Intro = styled.p`
  text-align: center;
  font-size: 1.05rem;
  line-height: 1.5;
  margin-bottom: 30px;
`;

const Methods = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

const MethodItem = styled.li`
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 16px 18px;
  margin-bottom: 12px;
  background-color: #f8f8f8;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
`;

const MethodLabel = styled.div`
  font-size: 0.85rem;
  color: #555;
  text-transform: uppercase;
  letter-spacing: 0.05em;
`;

const MethodValue = styled.a`
  display: block;
  color: #0C2340;
  font-size: 1.1rem;
  font-weight: 600;
  text-decoration: none;
  &:hover {
    color: #006331;
    text-decoration: underline;
  }
`;

const MethodBody = styled.div`
  flex: 1;
`;

const IconWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background-color: #006331;
  color: #fff;
  flex-shrink: 0;
`;

const Contact = () => {
  return (
    <ContactWrapper>
      <Title>Contact Us</Title>
      <Intro>
        We&apos;d love to hear about your project. Give us a call or text, which is the
        fastest way to reach us, or send a message on Facebook.
      </Intro>
      <Methods>
        <MethodItem>
          <IconWrap><Phone size={22} /></IconWrap>
          <MethodBody>
            <MethodLabel>Call or Text (preferred)</MethodLabel>
            <MethodValue href={PHONE_LINK}>{PHONE_DISPLAY}</MethodValue>
          </MethodBody>
        </MethodItem>
        <MethodItem>
          <IconWrap as="div" style={{ background: 'transparent', padding: 0 }}>
            <SocialIcon
              url={FACEBOOK_URL}
              target="_blank"
              rel="noopener noreferrer"
              style={{ height: 44, width: 44 }}
            />
          </IconWrap>
          <MethodBody>
            <MethodLabel>Facebook</MethodLabel>
            <MethodValue
              href={FACEBOOK_URL}
              target="_blank"
              rel="noopener noreferrer"
            >
              Message us on Facebook
            </MethodValue>
          </MethodBody>
        </MethodItem>
      </Methods>
    </ContactWrapper>
  );
};

export default Contact;
